/*! Wishlist Toast – uses mo-information-toast layout */
(function () {
  const EASE = 'cubic-bezier(.19,1,.22,1)';
  const D_IN = 420;
  const D_OUT = 360;

  const cfg = {
    duration: 4200,     // quanto resta visibile
    maxToasts: 1,       // uno alla volta (stile LV)
    topOffset: 130      // distanza dal top
  };

  function ensureRoot() {
    let root = document.getElementById('mo-wish-toast-root');
    if (!root) {
      root = document.createElement('div');
      root.id = 'mo-wish-toast-root';
      root.style.setProperty('--toast-top', cfg.topOffset + 'px');
      document.body.appendChild(root);
    }

    // Event delegation: click sul bottone chiudi
    if (!root._boundClose) {
      root.addEventListener('click', function (e) {
        const btn = e.target.closest('.mo-wish-toast__close');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        const toast = btn.closest('.mo-wish-toast');
        closeToast(toast);
      });
      root._boundClose = true;
    }

    // Escape per chiudere l’ultimo toast
    if (!root._boundEsc) {
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        const open = root.querySelectorAll('.mo-wish-toast');
        const last = open[open.length - 1];
        if (last) closeToast(last);
      });
      root._boundEsc = true;
    }

    return root;
  }

  function escapeHTML(s) {
    return String(s || '')
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#039;');
  }

  function closeToast(el) {
    if (!el || el._closing) return;
    el._closing = true;
    if (el._timer) { clearTimeout(el._timer); el._timer = null; }
    el.classList.remove('is-enter');
    el.classList.add('is-leave');
    setTimeout(() => el.remove(), D_OUT + 40);
  }

  function buildMarkup(product) {
    const img =
      (product && product.images && product.images[0]) ||
      (product && (product.image || product.featured_image)) || '';
    const title = escapeHTML(product && product.title);
    const wishlistUrl =
      window.WISHLIST_URL || '/pages/wishlist';

    const wrap = document.createElement('div');
    wrap.className = 'mo-wish-toast';
    wrap.setAttribute('role', 'status');
    wrap.setAttribute('aria-live', 'polite');

    wrap.innerHTML = `
      <button class="mo-wish-toast__close" aria-label="Chiudi" type="button">
        <svg viewBox="0 0 80 80" class="mo-icon-close" aria-hidden="true" focusable="false">
          <path d="M40 34.3 65.5 8.9l5.6 5.6L45.7 40l25.4 25.5-5.6 5.6L40 45.7 14.5 71.1l-5.6-5.6L34.3 40 8.9 14.5l5.6-5.6z"></path>
        </svg>
      </button>

      <div class="mo-information-toast">
        <div class="mo-information-toast__icon">
          <img class="mo-information-toast__img" src="${img}" alt="${title}">
        </div>
        <div class="mo-information-toast__message-wrapper">
          <div class="mo-information-toast__message body-s">
            <h2>L'articolo ${title} è stato aggiunto alla tua wishlist.</h2>
            <a class="signinobs" href="${wishlistUrl}">
              <h2 class="mo-information-toast__link">Accedi alla tua Wishlist</h2>
            </a>
          </div>
        </div>
      </div>
    `;
    return wrap;
  }

  function show(product) {
    const root = ensureRoot();

    // uno alla volta
    const open = root.querySelectorAll('.mo-wish-toast');
    if (open.length >= cfg.maxToasts) {
      open.forEach(el => closeToast(el));
    }

    const el = buildMarkup(product);
    root.appendChild(el);

    // Enter anim
    requestAnimationFrame(() => {
      el.style.transition = `opacity ${D_IN}ms ${EASE}, transform ${D_IN}ms ${EASE}`;
      el.classList.add('is-enter');
    });

    // Auto-dismiss (pausa all’hover)
    const armTimer = () => {
      el._timer = setTimeout(() => closeToast(el), cfg.duration);
    };
    const clear = () => { if (el._timer) { clearTimeout(el._timer); el._timer = null; } };

    el.addEventListener('mouseenter', clear);
    el.addEventListener('mouseleave', armTimer);
    armTimer();
  }

  function config(options = {}) {
    Object.assign(cfg, options);
    const root = document.getElementById('mo-wish-toast-root');
    if (root && options.topOffset != null) {
      root.style.setProperty('--toast-top', cfg.topOffset + 'px');
    }
  }

  // expose
  window.WishToast = { show, config };
})();
